export const SITE_SELECTION_REQUIRED_KEY = "siteSelectionRequired";

export const buildActiveSite = (site) => ({
  Site_ID: site.Site_ID,
  Name: site.Name,
  value: site.Site_ID,
  label: site.Name,
});

export const getStoredActiveSite = () => {
  try {
    const stored = JSON.parse(localStorage.getItem("site"));
    const siteId = stored?.Site_ID ?? stored?.value;
    const name = stored?.Name ?? stored?.label;
    return siteId ? buildActiveSite({ Site_ID: siteId, Name: name || "Selected site" }) : null;
  } catch {
    return null;
  }
};

export const requireSiteSelection = () => {
  sessionStorage.setItem(SITE_SELECTION_REQUIRED_KEY, "true");
  localStorage.removeItem("site");
};

export const completeSiteSelection = (site) => {
  const activeSite = buildActiveSite(site);
  localStorage.setItem("site", JSON.stringify(activeSite));
  sessionStorage.removeItem(SITE_SELECTION_REQUIRED_KEY);
  return activeSite;
};

export const bypassSiteSelection = () => {
  sessionStorage.removeItem(SITE_SELECTION_REQUIRED_KEY);
};

export const isSiteSelectionRequired = () =>
  sessionStorage.getItem(SITE_SELECTION_REQUIRED_KEY) === "true";
